import {
  ICreateUpdateFormField,
  ReadCardField,
} from '../../CommonInterfaces/Form';

export const ResultReadFields: ReadCardField[] = [
  {
    title: 'Идентификатор',
    name: 'result.id',
  },
  {
    title: 'Параллель',
    name: 'result.event_class',
  },
  {
    title: 'Класс',
    name: 'result.student_class',
  },
  {
    title: 'Балл',
    name: 'result.points',
  },
  {
    title: 'Место',
    name: 'result.place',
  },
  {
    title: 'Диплом',
    name: 'result.place_type',
  },
  {
    title: 'Команда',
    name: 'result.command_name',
  },
  {
    title: 'Фамилия ученика',
    name: 'student.last_name',
  },
  {
    title: 'Имя ученика',
    name: 'student.first_name',
  },
  {
    title: 'Отчество ученика',
    name: 'student.second_name',
  },
  {
    title: 'День рождения ученика',
    name: 'student.birthday',
  },
  {
    title: 'Пол ученика',
    name: 'student.gender',
  },
  {
    title: 'Наличие гражданства',
    name: 'student.is_citizen',
  },
  {
    title: 'ОВЗ',
    name: 'student.has_disability',
  },
  {
    title: 'ОУ ученика',
    name: 'student.school.name',
  },
  {
    title: 'Район ОУ ученика',
    name: 'student.school.district.name',
  },

  {
    title: 'Пользователь',
    name: 'user.name',
  },
  {
    title: 'Мероприятие',
    name: 'event.name',
  },
  {
    title: 'Предмет',
    name: 'subject.name',
  },
  {
    title: 'Загрузка',
    name: 'upload.id',
  },
  {
    title: 'Преподаватели',
    name: 'teachers',
  },
  {
    title: 'Изменён',
    name: 'result.updated_at',
  },
];

const BaseResultUpdateFields: ICreateUpdateFormField[] = [
  {
    title: 'Предмет',
    name: 'result.subject_id',
  },
  {
    title: 'Параллель',
    name: 'result.event_class',
  },
  {
    title: 'Класс',
    name: 'result.student_class',
  },
  {
    title: 'Балл',
    name: 'result.points',
  },
  {
    title: 'Место',
    name: 'result.place',
  },
  {
    title: 'Диплом',
    name: 'result.place_type',
    type: 'place_type',
  },
  {
    title: 'Команда',
    name: 'result.command_name',
  },
];

/** Fields to exclude from read-only display on the update page (editable + subject name). */
const editableFieldNames = new Set([
  'result.event_class',
  'result.student_class',
  'result.points',
  'result.place',
  'result.place_type',
  'result.command_name',
  'subject.name',
]);

/** Read-only fields displayed on the update page alongside the editable form. */
export const ResultUpdateReadOnlyFields: ReadCardField[] = ResultReadFields.filter(
  (field) => !editableFieldNames.has(field.name),
);

export const ResultUpdateFields: ICreateUpdateFormField[] = [
  ...BaseResultUpdateFields,
];
export const ResultInEventUpdateFields: ICreateUpdateFormField[] = [
  ...BaseResultUpdateFields,
];
